import { render, staticRenderFns } from "./ShopContactsComponent.vue?vue&type=template&id=1c132995"
import script from "./ShopContactsComponent.vue?vue&type=script&lang=js"
export * from "./ShopContactsComponent.vue?vue&type=script&lang=js"
import style0 from "./ShopContactsComponent.vue?vue&type=style&index=0&id=1c132995&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports